<template>
  <div>
    <listar-sla :refresh_componentes="this.$store.state.refreshComponente.refreshComponente"/>
  </div>
</template>
<script>
import listarSla from './ListarSla.vue'

export default {
  components: {
    'listar-sla': listarSla
  }
}
</script>



// WEBPACK FOOTER //
// IndexSla.vue?5f7c3d38